import React from 'react'
import { Box, CardMedia, Divider, Icon, Typography } from '@mui/material'
import defaultImage from 'assets/images/default_avatar.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getAllSubmission } from 'services/api/modules/performance/appraisal/submission'

const EDDrawerBody = ({ title, staff }) => {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const evaluationId = pathname.split('/').pop()
  const staffId = staff?.staff_id
  const { data } = useQuery(
    ['getAllSubmission', staffId, evaluationId, 'EDDrawer'],
    async () => {
      const { data } = await getAllSubmission(staffId, evaluationId)
      return data
    },
    {
      enabled: !!staffId,
    }
  )
  const handleView = (
    submissionId,
    evaluationTitle,
    evaluationScore,
    teamMemberDetails,
    reviewerLength
  ) => {
    navigate(`/app/appraisal-cycle/evaluation/${state.item.id}/${submissionId}/result`, {
      state: {
        ...state,
        evaluationDetails: {
          evaluation_title: evaluationTitle,
          evaluation_score: evaluationScore,
        },
        appraisalTabsValue: 1,
        teamMemberDetails,
        reviewerLength,
        submissionId: submissionId,
      },
    })
  }
  const reviewers = data?.filter((detail) => detail?.roles?.includes('reviewee'))
  return (
    <>
      <Box px={5} py={2} display="flex" alignItems="center" gap={2}>
        <CardMedia
          component="img"
          sx={{
            height: 45,
            width: 45,
            objectFit: 'cover',
            borderRadius: '50%',
            marginRight: 2,
          }}
          src={staff?.profile_image || defaultImage}
        />
        <Box display="flex" flexDirection="column">
          <Typography variant="h4">{staff?.name}</Typography>
          <Typography variant="body1" color="light-gray-text.main">
            {staff?.designation}
          </Typography>
        </Box>
      </Box>
      <Divider />

      <Box
        px={5}
        py={2.5}
        display="flex"
        flexDirection={reviewers?.length > 1 ? 'column' : 'row'}
        sx={
          reviewers?.length > 1 ? null : { alignItems: 'center', justifyContent: 'space-between' }
        }
        gap={2}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            display="flex"
            width={30}
            height={30}
            borderRadius="50%"
            bgcolor={staff?.total_participant_score ? 'light-yellow-01.main' : null}
            justifyContent="center"
            alignItems="center"
          >
            <Icon
              sx={
                staff?.total_participant_score
                  ? {
                      color: 'yellow-01.main',
                      fontSize: '24px',
                    }
                  : {
                      color: 'gray-inactive-button.main',
                      fontSize: '24px',
                    }
              }
            >
              workspace_premium
            </Icon>
          </Box>
          <Typography
            width={25}
            variant="body1"
            color={staff?.total_participant_score ? 'yellow-02.main' : 'light-gray-text.main'}
          >
            {staff?.total_participant_score
              ? Math.round(staff?.total_participant_score * 50) / 10
              : '--'}
          </Typography>
          <Typography variant="body1">{title}</Typography>
        </Box>
        {reviewers?.length > 1 ? (
          reviewers?.map((r, index) => (
            <Box key={index} display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" gap={2}>
                <Box width={30}></Box>
                <Typography
                  width={25}
                  variant="body1"
                  color={r?.score ? 'yellow-02.main' : 'light-gray-text.main'}
                >
                  {r?.score ? Math.round(r?.score * 50) / 10 : '--'}
                </Typography>
                <Typography variant="body1">Reviewer {index + 1}</Typography>
              </Box>
              <Typography
                variant="body1"
                color="alternate.main"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() =>
                  handleView(r?.submission_id, title, r?.score, staff, reviewers.length)
                }
              >
                View
              </Typography>
            </Box>
          ))
        ) : (
          <Typography
            variant="body1"
            color="alternate.main"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() =>
              handleView(reviewers[0]?.submission_id, title, reviewers[0]?.score, staff)
            }
          >
            View
          </Typography>
        )}
      </Box>
      <Divider />
    </>
  )
}

export default EDDrawerBody
